



























































import { Component, Watch, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
import dayjs from 'dayjs';
import Loading from '../components/Loading.vue';
@Component({
  components: {
    Loading,
  },
})
export default class Upload extends Vue {
  private user: any;
  private dataJson: any = {
    SKUPath: '',
    letterPathArr: [],
    beforeLetterName: '',
    orderPath: '',
  };
  private spinning: boolean = false;
  private headers: any = {
    authorization: 'authorization-text',
  };
  private txtFileArr: any = [];
  private nameCVS: string = '';
  private upDisabled = true;
  private upOrderIDAdndownDisabled = true;
  private skuAsindownDisabled = true;
  private downDisabled = true;
  // @Watch('productSku') private onChildChanged(newVal: any, oldVal: any): void {
  //   if (newVal.length > 3) {
  //     this.upDisabled = false;
  //     this.upData.sku = newVal;
  //     this.orderIDData.sku = newVal;
  //   } else {
  //     this.upDisabled = true;
  //     this.downDisabled = true;
  //   }
  // }
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private SKUChange(info: any) {
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file uploaded successfully`);
      this.dataJson.SKUPath = info.file.response.path;
      this.upDisabled = false;
      // console.log(this.dataJson);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`);
    }
  }
  private letterChange(info: any) {
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file uploaded successfully`);
      this.dataJson.letterPathArr.push(info.file.response.path);
      this.dataJson.beforeLetterName = info.file.name;
      this.upOrderIDAdndownDisabled = false;
      // console.log(this.dataJson);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`);
    }
  }
  private txtChange(info: any) {
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      const obj = {
        beforeName: info.file.name,
        path: info.file.response.path,
      };
      this.txtFileArr.push(obj);
      this.skuAsindownDisabled = false;
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`);
    }
  }

  private OrderIDChange(info: any) {
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file uploaded successfully`);
      this.downDisabled = false;
      this.dataJson.orderPath = info.file.response.path;
      // console.log(this.dataJson);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`);
    }
  }
  private downloadLetterClick() {
    this.spinning = true;
    const that = this;
    const args = {
      dataJson: this.dataJson,
    };
    this.axios.post('/api/getLetterZip', args, { responseType: 'blob'}).then((res) => {
      let name = '';
      // console.log(res);
      try {
        name = res.headers['content-disposition'].split('filename="')[1];
        name = name.substring(0, name.length - 1);
      } catch ( err ) {
        console.log(err);
        name = 'noName.zip';
      }
      that.downloadFile(res.data, name);
    });
  }
  private downloadSkuAsinClick() {
    this.spinning = true;
    const that = this;
    const args = {
      txtFileArr: this.txtFileArr,
    };
    this.axios.post('/api/getSkuAsinInfoCSV', args, { responseType: 'blob'}).then((res) => {
      let name = '';
      // console.log(res);
      try {
        name = res.headers['content-disposition'].split('filename="')[1];
        name = name.substring(0, name.length - 1);
      } catch ( err ) {
        console.log(err);
        name = 'noName.csv';
      }
      that.downloadFile(res.data, name);
    });
  }
  // 下载orderID 模板
  private getOrderIDTemplate() {
    this.spinning = true;
    const that = this;
    const args = {};
    this.axios.post('/api/getOrderIDTemplate', args , { responseType: 'blob'}).then((res) => {
      that.downloadFile(res.data, 'orderIDTemplate.csv');
      // 清除上传记录
      that.txtFileArr.splice(0, that.txtFileArr.length);
    });
  }
  // 下载文件 方法 传入blob数据,和 定义的文件名称
  private downloadFile(data: any, fileName: any) {
    if (!data) {
      return;
    }
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    // 获取文件名
    // download 属性定义了下载链接的地址而不是跳转路径
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    this.spinning = false;
  }
}

